// A promo code typed into the restaurant page's cart, checked there and then
// carried to checkout, which applies it as if it had been typed at checkout.
// Per restaurant and per tab (sessionStorage): a code for one restaurant never
// follows the customer to another.

const KEY = "rmf.pendingPromo";

export function readPendingPromo(restaurantId) {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || "null");
    if (!saved?.code) return null;
    if (restaurantId && String(saved.restaurantId) !== String(restaurantId)) return null;
    return saved;
  } catch (e) {
    return null;
  }
}

export function savePendingPromo(code, restaurantId) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ code, restaurantId: String(restaurantId || "") }));
  } catch (e) {
    // Storage blocked (private mode, partitioned iframe): the code is simply
    // typed again at checkout.
  }
}

export function clearPendingPromo() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {
    // Nothing saved to clear.
  }
}
